import { getDateForServer } from 'utils/date'

export const FINISHED_ORDERS_DEFAULT_PERIOD_DAYS = 30

export const getDefaultFinishedOrdersPeriod = () => {
  const dateTo = new Date()
  const dateFrom = new Date()
  dateFrom.setDate(dateFrom.getDate() - FINISHED_ORDERS_DEFAULT_PERIOD_DAYS)

  return {
    dateFrom: getDateForServer(dateFrom),
    dateTo: getDateForServer(dateTo),
  }
}

export const isValidFinishedPeriodDate = (value: string) => /^\d{4}-\d{2}-\d{2}$/.test(value)

export const getPeriodFromUrl = () => {
  const searchParams = new URLSearchParams(window.location.search)
  const dateFrom = searchParams.get('dateFrom') ?? ''
  const dateTo = searchParams.get('dateTo') ?? ''

  if (!isValidFinishedPeriodDate(dateFrom) || !isValidFinishedPeriodDate(dateTo)) {
    return null
  }

  return { dateFrom, dateTo }
}

export const normalizeFinishedOrdersPeriod = (dateFrom: string, dateTo: string) => {
  if (!isValidFinishedPeriodDate(dateFrom) || !isValidFinishedPeriodDate(dateTo)) {
    return getDefaultFinishedOrdersPeriod()
  }

  if (dateFrom <= dateTo) {
    return { dateFrom, dateTo }
  }

  return { dateFrom: dateTo, dateTo: dateFrom }
}
